import { marked } from "marked";
import DOMPurify from "dompurify";
import { Directive } from "vue";

const markdownDirective = <Directive>{
  created(el, binding) {
    // Convert markdown to HTML
    const markdown = binding.value;
    const rawHtml = marked(markdown);

    // Sanitize the HTML
    el.innerHTML = DOMPurify.sanitize(rawHtml);
  },
  updated(el, binding) {
    // Update the HTML if the markdown content changes
    if (binding.value !== binding.oldValue) {
      const markdown = binding.value;
      const rawHtml = marked(markdown);

      // Sanitize the HTML
      el.innerHTML = DOMPurify.sanitize(rawHtml);
    }
  },
};

export default markdownDirective;
